import axios from 'axios'
import env from '@/util/Env'
import {Response} from '@/domain/Common'

export default class Const {

  public static error(key: string): string {
    if (!this.instance) {
      this.update()
    }
    return this.instance?.error[key] || ''
  }

  public static label(key: string): string {
    if (!this.instance) {
      this.update()
    }
    return this.instance?.label[key] || ''
  }

  public static help(key: string): Help {
    if (!this.instance) {
      this.update()
    }
    return this.instance?.help[key] || {title: '', message: ''}
  }


  public static async update() {
    this.instance = await axios
      .get<Response<ConstValue>>(`${env.ResUrl}/const.json`)
      .then((res) => res.data.result)
  }
  private static instance: ConstValue | null = null
}

interface ConstValue {
  error: Dic,
  help: HelpDic,
  label: Dic
}

interface Dic {
  [key: string]: string
}

interface HelpDic {
  [key: string]: Help
}

interface Help {
  title: string
  message: string
}
